import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faSpinner,
  faAngleRight,
  faAngleLeft,
  faCheck,
  faLock,
  faExclamation,
  faBars,
  faChevronLeft,
  faHeart,
  faEllipsisV,
  faArrowRight,
  faRedoAlt,
  faGear,
  faExclamationCircle,
  faCopy,
  faTimes,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faSpinner,
  faAngleLeft,
  faArrowRight,
  faAngleRight,
  faCheck,
  faLock,
  faExclamation,
  faBars,
  faChevronLeft,
  faHeart,
  faEllipsisV,
  faRedoAlt,
  faGear,
  faExclamationCircle,
  faCopy,
  faTimes,
  faCheckCircle,
);
